import { useQuery } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { courseResourcesApi } from "./courseResourcesApi";
import { groupResourcesByFolder } from "./useCourseResources";

export const useCourseResourceTab = (courseId: number, courseResourceTabId: number) => {
  const { data, isLoading, isFetched } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_RESOURCE_TAB(courseId, courseResourceTabId),
    queryFn: () => courseResourcesApi.getTabById(courseId, courseResourceTabId),
  });

  return {
    tab: data?.data
      ? {
          id: data.data.id,
          name: data.data.name,
          icon: data.data.icon,
          folders: groupResourcesByFolder(data.data.resources).sort((a, b) => a.folderOrder - b.folderOrder),
        }
      : undefined,
    resources: data?.data?.resources ?? [],
    isLoading,
    isFetched,
  };
};
